<template>		
	<div class="auth-form">
		<div class="text-center logo"><img :src="stylePathToLogo || '/static/img/logo/logo.png'" /></div>

		<h4 class="text-center">{{ 'page/user_register' | ftc }}</h4>

		<template v-if="errorWithLogout">

			<div class="w5-field text-center alert alert-danger margin-20-0">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="errorWithLogout"></p>
			</div>
			<button type="button" class="btn btn-submit btn-primary btn-block" @click.prevent="logOut">{{ 'login/logout' | ftc }}</button>

		</template>
		<template v-if="!errorWithLogout">

			<fieldset :disabled="form_Loading">
			<div class="w5-field" v-show="successMessage === false">
				<span class="al" :class="{ animated: animatedEmail, focused: isFocusedEmail, unfocused: !isFocusedEmail }">{{ 'main/email' | ftc }}<span class="required-field"> *</span></span>
				<input type="text" aria-describedby="emailHelp" :placeholder="`main/email *` | ftc" :class=" { haserror: form_ErrorMessage }"
				ref="email" v-model="email" @focus="OnFocus" @blur="OnBlur" @keyup="OnKeyUp">
				<div class="alert alert-danger w5-error-block" role="alert" v-show="form_ErrorMessage !== false" style="margin-bottom: 0" v-withSafeTags="localeFtc(form_ErrorMessage)"></div>
			</div>
			</fieldset>
			
			<div class="w5-field text-center" v-show="successMessage === false">
				<img src="/static/img/loading32.gif" v-show="form_Loading" />
				<button class="btn btn-submit btn-primary btn-block" type="button"
				ref="button" @click="registration" v-show="!form_Loading">{{ 'page/user_register' | ftc }}</button>
			</div>

			<div class="w5-field text-center alert alert-success margin-20-0" v-show="successMessage !== false">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="successMessage"></p>
			</div>

			<div class="w5-field" v-show="!form_Loading">
				<span v-show="successMessage === false">{{ 'login/already_registered' | ftc }}</span>
				<router-link v-if="successMessage === false" to="/login">{{ 'main/enter' | ftc }}</router-link>
				<button v-else class="btn btn-submit btn-primary btn-block" type="button" @click="successToPanel" v-show="!form_Loading">{{ 'main/enter' | ftc }}</button>
			</div>
		</template>

	</div>		
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'registrationForm',
	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			email: '',
			successMessage: false,
			// по умолчанию выключена, обычно включается при первом фокусе на поле
			animatedEmail: false,
			// в фокусе поле или нет
			isFocusedEmail: false,
			// ошибка с разлогином
			errorWithLogout: ''
		}
	},
	//=========================================================================
	// событие: компонент создан
	//=========================================================================
	created() {
		// если пользователь авторизован - редирект на главную страницу
		if (this.$store.state.is_auth)
		{
			// делаем редирект
			return this.$router.push('/')
		}
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// событие: фокус на поле формы
		//---------------------------------------------------------------------
		OnFocus(e) {
			// при первом фокусе - включаем анимацию
			this.animatedEmail = true
			// добавляем класс "focused"
			this.isFocusedEmail = true
			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
		},
		//---------------------------------------------------------------------
		// событие: потеря фокуса полем формы
		//---------------------------------------------------------------------
		OnBlur(e) {
			// убираем класс "focused" только если значение пустое
			if (e && e.target)
			{
				if (e.target.value === null || e.target.value === undefined || e.target.value === '')
					this.isFocusedEmail = false
			}
			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
		},
		//---------------------------------------------------------------------
		// событие: клавишы по полю
		//---------------------------------------------------------------------
		OnKeyUp(e) {
			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
			this.enterOnInput(e)
		},
		//---------------------------------------------------------------------
		// реакция на отрицательный результат запроса
		//---------------------------------------------------------------------
		failRequest(error) {
			this.errorWithLogout = ''
			let _msg = this.localeFtc('main/validation_error')

			if (error && typeof error === 'object' && error['email'])
			{
				if (Array.isArray(error['email']) && error['email'].length) _msg = this.localeFtc(error['email'][0])
				else _msg = this.localeFtc(error['email'])
			}

			if (error && typeof error === 'object' &&
				error.data &&
				error.data.status === 'error' && error.data.content && error.data.title &&
				error.data.content === 'user/need_logout')
			{
				this.errorWithLogout = '<b>' + this.localeFtc(error.data.title) + '</b><br><br>' + this.localeFtc(error.data.content)
				return
			}

			if (this.$refs['email'] && this.$refs['email'].parentNode) this.addClass(this.$refs['email'].parentNode, 'has-error')
			this.form_ErrorMessage = this.localeFtc(_msg)
		},
		//---------------------------------------------------------------------
		// запрос на регистрацию
		//---------------------------------------------------------------------
		registration() {
			// обнуляем ошибку
			this.form_ErrorMessage = false

			// проверка полей
			if (this.email === null || this.email === undefined || String(this.email).trim() === '' || !Helper.validateEmail(this.email))
			{
				if (this.$refs['email'] && this.$refs['email'].parentNode) this.addClass(this.$refs['email'].parentNode, 'has-error')
				this.form_ErrorMessage = this.localeFtc('validators/error_email')
				return
			}

			// готовим объект запроса и url запроса
			let _obj = {
				'email': this.email,
				'locale': this.$store.state.lang
			}
			let _url = '/user/register'

			// запрос на аутентификацию
			this.forms_GetThenPost(_url, _obj,
				// успех
				(data) => {
					// покажем сообщени
					this.successMessage = this.localeFtc('register/success<br><br> register/email_sent')

					// яндекс.метрика
					/*
					let _ym = new window.Ya.Metrika({ id: 25376711 })
					if (_ym && 'reachGoal' in _ym) _ym.reachGoal('USRREG', { 'userLogin': this.email })
					*/

					// обнуляем поле
					this.email = ''
				},
				// неудача
				(error) => {
					// если это 403 Blacklisted
					if (error && error.status === 403 && error.data && error.data.content === 'Blacklisted')
					{
						// ставим текст сообщения
						this.form_ErrorMessage = this.localeFtc('login/blacklisted')
					}
					// иная ошибка
					else this.failRequest(error)
				}
			)
		},
		//---------------------------------------------------------------------
		// кликнули после успешной регистрации - переводим в панель,
		// пользователь уже залогинен
		//---------------------------------------------------------------------
		successToPanel() {
			// "тяжелый" переход - c загрузкой всего приложения
			// иначе в FF начинает все время спрашивать "сохранить пароль?"
			window.location.href = '/'
			window.location.reload(true)
		},

		//---------------------------------------------------------------------
		// процедура выхода
		//---------------------------------------------------------------------
		logOut() {
			// запрос на выход из системы
			this.forms_GetThenPost('/logout', false,
				// успех
				(data) => {
					this.$store.commit('dropAuth')
					this.$router.push('/login')
				},
				// провал
				(data) => {
					this.$router.push('/')
				}
			)
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// Registration.vue?1a2586bc